import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated'); // ログアウト時に認証情報を削除
    navigate('/'); // ログイン画面にリダイレクト
  };

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          クリニックマネージメント会社管理画面
        </Typography>
        <Button color="inherit" component={Link} to="/dashboard">Home</Button>
        <Button color="inherit" component={Link} to="/dashboard/users">Users</Button>
        <Button color="inherit" component={Link} to="/dashboard/settings">Settings</Button>
        <Button color="inherit" onClick={handleLogout}>Logout</Button>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
